import React, { useState } from 'react';
import { useDebounce } from 'react-use';
import SearchIcon from '@mui/icons-material/Search';
import { IconTextField } from './IconTextField';
interface SearchBarProps {
  handleSumbit: (setSearchTerm: string) => void;
  hint: string;
  InputPropsStyle?: any;
  sx?: any;
}
const boarderRadius = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '20px',
    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.2)',
  },
};
export const SearchBar: React.FC<SearchBarProps> = ({
  handleSumbit,
  hint,
  InputPropsStyle,
  sx,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  useDebounce(
    () => {
      onSubmit();
    },
    250,
    [searchTerm]
  );
  const onSubmit = () => {
    handleSumbit(searchTerm);
  }
  return (
    <IconTextField
      icon = {<SearchIcon />}
      onIconClick = {onSubmit}
      value={searchTerm}
      onChange={({ currentTarget }) => setSearchTerm(currentTarget.value)}
      placeholder={hint}
      margin="normal"
      sx={{...boarderRadius, ...sx}}
      InputPropsStyle={InputPropsStyle}
    />
  );
};
